import React, { useState, useEffect } from 'react'
import { Modal, Button, Form, Alert } from 'react-bootstrap'
import Select from 'react-select'
import { chatsAPI } from '../../services/chatsApi'

const InviteUsersModal = ({ show, onHide, chatId, onInvited }) => {
  const [options, setOptions] = useState([])
  const [selected, setSelected] = useState([])
  const [error, setError] = useState(null)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (show && chatId) {
      setSelected([])
      setError(null)
      loadUsers()
    }
  }, [show, chatId])

  const loadUsers = async () => {
    try {
      const response = await chatsAPI.invitableUsers(chatId)
      setOptions(response.data.map((u) => ({ value: u.id, label: u.email })))
    } catch (err) {
      console.error('Error loading users:', err)
      setError('Не удалось загрузить список пользователей')
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (selected.length === 0) {
      setError('Выберите хотя бы одного пользователя')
      return
    }

    try {
      setSaving(true)
      const response = await chatsAPI.invite(chatId, selected.map((s) => s.value))
      onInvited?.(response.data)
      onHide()
    } catch (err) {
      console.error('Error inviting users:', err)
      setError('Не удалось пригласить пользователей')
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Пригласить в чат</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form.Group>
            <Form.Label>Пользователи</Form.Label>
            <Select
              isMulti
              options={options}
              value={selected}
              onChange={setSelected}
              placeholder="Выберите пользователей..."
              noOptionsMessage={() => 'Нет доступных пользователей'}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Отмена
          </Button>
          <Button variant="primary" type="submit" disabled={saving}>
            {saving ? 'Приглашение...' : 'Пригласить'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default InviteUsersModal
